/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_api as api,
  rec_bC as bC,
} from "../../runtime/index.jsx";
export function Componente_xC_120_67() {
  let e = Go(),
    [t, n] = (0, React.useState)(!1),
    [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(!1);
  (0, React.useEffect)(() => {
    let e = !0,
      t = !1;
    try {
      t = sessionStorage.getItem(bC) === `1`;
    } catch {}
    if (!t)
      return (
        api(`/usuarios/yo/celular`, {
          sinCache: !0,
        })
          .then((t) => {
            e && t && t.celular === null && n(!0);
          })
          .catch(() => {}),
        () => {
          e = !1;
        }
      );
  }, []);
  function l() {
    try {
      sessionStorage.setItem(bC, `1`);
    } catch {}
    n(!1);
  }
  async function u() {
    (o(``), c(!0));
    try {
      (await api(`/usuarios/yo/celular`, {
        method: `PUT`,
        body: JSON.stringify({
          celular: r,
        }),
      }),
        e.ok(`Celular guardado`),
        n(!1));
    } catch (e) {
      o(e.message);
    } finally {
      c(!1);
    }
  }
  return t ? (
    <Modal
      titulo={`Tu celular`}
      onClose={l}
      children={
        <div
          className={`flex flex-col gap-3`}
          children={[
            <p
              className={`text-sm text-(--text)`}
              children={`Por WhatsApp te llegan los avisos que no se pueden perder: un acta que se va a borrar, tus tareas del día.`}
            />,
            <input
              className={`${Lo} min-h-11`}
              inputMode={`tel`}
              aria-label={`Celular`}
              placeholder={`987 654 321`}
              value={r}
              maxLength={22}
              onChange={(e) => i(e.target.value.replace(/[^\d+ ()-]/g, ``))}
            />,
            a && (
              <p
                role={`alert`}
                className={`text-sm text-(--error-texto)`}
                children={a}
              />
            ),
            <div
              className={`flex justify-end gap-2`}
              children={[
                <AccionAsync
                  variante={`texto`}
                  className={`min-h-11`}
                  onClick={l}
                  children={`Ahora no`}
                />,
                <AccionAsync
                  className={`min-h-11`}
                  disabled={s || r.replace(/\D/g, ``).length < 9}
                  onClick={u}
                  children={`Guardar`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  ) : null;
}
